module.exports = __webpack_public_path__ + "img/kn21_samurai01skin_shop.9896efd0.png";